const transformDateFunction = (a, b) => {
  return date => {
    const digitGroups = date.match(/\d+/g);
    if (!digitGroups || digitGroups.length < 3) return date;

    const year = digitGroups[2].padStart(4, '0');
    const month = digitGroups[a].padStart(2, '0');
    const day = digitGroups[b].padStart(2, '0');

    if (Number(month) > 12) {
      // If the month is invalid, try swapping day/month (handles mixed input formats).
      const altMonth = digitGroups[b].padStart(2, '0');
      const altDay = digitGroups[a].padStart(2, '0');
      if (Number(altMonth) <= 12) {
        return `${year}-${altMonth}-${altDay}`;
      }
    }

    return `${year}-${month}-${day}`;
  };
};

const defaultDateTransform = transformDateFunction(1, 0);

const dateOfBirth = {
  en: transformDateFunction(0, 1), // transform mm/dd/yyyy
  es: defaultDateTransform, // transform dd/mm/yyyy 
};

const splitUpcomingPayment = (paymentStr) => {
  const match = paymentStr.match(/(\d.*)/); // Match everything starting from the first number
  if (match) {
    return [
      paymentStr.slice(0, match.index).trim(), // Before the number
      paymentStr.slice(match.index).trim() // From the first number onward
    ];
  }
  return [paymentStr]; // In case no match found
};

const splitLastPayment = (paymentStr) => {
  const match = paymentStr.match(/(\d{1,2}\sde\s\w+|\w+\s\d{1,2},\s\d{4})/i); // Match the date regardless of format
  if (match) {
    return [
      paymentStr.slice(0, match.index).trim(), // Before the date
      paymentStr.slice(match.index).trim() // The date itself and after
    ];
  }
  return [paymentStr]; // In case no match found
};

export {
  dateOfBirth,
  splitUpcomingPayment,
  splitLastPayment
};
